import { expandBorderRadii, paddingHorizontal, paddingVertical } from "@gadgetinc/themes/src/utils";
import { styled } from "baseui";
import type { ReactNode } from "react";
import React from "react";
import type { StyleObject } from "styletron-react";

export const Pill = styled<{ $size?: "large" | "compact"; $color: "purple" | "green" | "yellow" }, "span">(
  "span",
  ({ $theme, $size, $color }) => {
    let backgroundColor;
    let color;
    switch ($color) {
      case "purple": {
        backgroundColor = $theme.colors.purple100;
        color = $theme.colors.purple400;
        break;
      }
      case "yellow": {
        backgroundColor = $theme.colors.yellow50;
        color = $theme.colors.yellow600;
        break;
      }
      case "green": {
        backgroundColor = $theme.colors.green100;
        color = $theme.colors.green600;
        break;
      }
    }

    return {
      ...paddingHorizontal($theme.sizing.scale300),
      ...paddingVertical($theme.sizing.scale0),
      display: "inline-flex",
      alignItems: "center",
      ...expandBorderRadii("100px"),
      whiteSpace: "nowrap",
      ...($size == "large" ? $theme.typography.MonoLabelSmall : $theme.typography.MonoLabelXSmall),
      height: $size == "large" ? $theme.sizing.scale700 : $theme.sizing.scale600,
      backgroundColor,
      color,
    };
  }
);

export const BetaPill = (props: { children?: ReactNode; $style?: StyleObject }) => {
  return (
    <Pill $style={props.$style} $color="purple">
      {props.children ?? "Beta"}
    </Pill>
  );
};

export const DeprecatedPill = (props: { children?: ReactNode; $style?: StyleObject }) => {
  return (
    <Pill $style={props.$style} $color="yellow">
      {props.children ?? "deprecated"}
    </Pill>
  );
};

export const NewPill = (props: { children?: ReactNode; $style?: StyleObject }) => {
  return (
    <Pill $style={props.$style} $color="purple">
      {props.children ?? "new"}
    </Pill>
  );
};
